import { Accordion, AccordionDetails, AccordionSummary, Box, Image, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useState } from "react"

type Props = {
    base64Image: string
}

export default function VehicleImage({ base64Image }: Props) {
    const { translateText } = useLocalization()
    const [expanded, setExpanded] = useState(true)
    return (
        <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)} disableGutters>
            <AccordionSummary sx={{ pl: 1 }}>
                <Typography variant="h4">{translateText(1633)}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box display="flex" justifyContent="center">
                    <Image src={`data:image;base64,${base64Image}`} />
                </Box>
            </AccordionDetails>
        </Accordion>
    )
}
